import { create } from 'zustand'

import { Benefit, User } from '@/network/api/user/types'

interface UserState {
  userInfo: {
    user: User
    benefit: Benefit
  } | null
  isLoggedIn: boolean
  setUser: (user: any) => void
  clearUser: () => void
}

export const useUserStore = create<UserState>((set) => ({
  isLoggedIn: false,
  userInfo: null,
  setUser: (payload) => set({ userInfo: payload, isLoggedIn: true }),
  clearUser: () => {
    set({ userInfo: null, isLoggedIn: false })
    localStorage.removeItem('bobai-token')
    window.location.reload()
  },
}))
